/*
 * Copyright (C) 2026 - Potentially Ltd
 *
 * Please see distribution for license.
 */

export class CertificateHelper {
  /**
   * `expiresOn` is an ISO local date (`yyyy-MM-dd`). Comparing calendar-date strings directly (rather than
   * `new Date(expiresOn) < new Date()`) avoids parsing the date-only string as UTC midnight, which reads
   * certificates as expired up to a day early for users west of UTC.
   */
  static isExpired(expiresOn: string | undefined): boolean {
    if (!expiresOn) return false;

    const today = new Date();
    const todayLocal = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;

    return expiresOn < todayLocal;
  }
}
